function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg102Andorra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 170.663,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341.337,
    style: {
      fill: "#D80027"
    },
    width: 170.663,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,321.855c0-30.639,0-66.783,0-66.783h50.087v25.043c0,4.351-8.348,20.292-28.951,33.391   C269.331,318.47,261.254,320.066,256,321.855z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.913,
    y: 204.989,
    style: {
      fill: "#D80027"
    },
    width: 50.087,
    height: 50.087
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M281.043,188.29c0-9.22-7.475-16.696-16.696-16.696c-3.045,0-5.89,0.828-8.348,2.252  c-2.458-1.424-5.303-2.252-8.348-2.252c-9.22,0-16.696,7.475-16.696,16.696h-41.739v83.477c0,31.077,24.68,49.05,44.033,58.366  c-1.448,2.473-2.294,5.344-2.294,8.418c0,9.22,7.475,16.696,16.696,16.696c3.045,0,5.89-0.828,8.348-2.252  c2.458,1.424,5.303,2.252,8.348,2.252c9.22,0,16.696-7.475,16.696-16.696c0-3.074-0.846-5.945-2.295-8.418  c19.354-9.316,44.034-27.288,44.034-58.366V188.29L281.043,188.29L281.043,188.29z M297.739,271.767c0,4.351,0,17.589-20.604,30.688  c-7.805,4.962-15.882,8.179-21.136,9.968c-5.254-1.79-13.331-5.006-21.136-9.968c-20.604-13.098-20.604-26.337-20.604-30.688  v-58.434h83.478V271.767z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg102Andorra);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };